import React from "react";

function MapSection() {
  return (
    <div className="map-section">
      <div className="map-items">
        <div className="googpemap">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.814071077146!2d36.92033281475783!3d-1.3633051989999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f06e7c6e7c6e7%3A0x7c6e7c6e7c6e7c6e!2sSyokimau%2C%20Kenya!5e0!3m2!1sen!2ske!4v1697681234567!5m2!1sen!2ske"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Fayah Travels Location"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default MapSection;